import { Link } from 'react-router-dom';

const footerLinks = {
  快速链接: [
    { label: '首页', href: '/' },
    { label: '分类浏览', href: '/category/all' },
    { label: '最新更新', href: '/category/all' },
    { label: '关于我们', href: '/about' },
  ],
  热门分类: [
    { label: '日本h漫画', href: '/category/japanese' },
    { label: '恋爱漫画', href: '/category/romance' },
    { label: '剧情漫画', href: '/category/drama' },
    { label: '奇幻漫画', href: '/category/fantasy' },
  ],
  帮助中心: [
    { label: '常见问题', href: '/about#faq' },
    { label: '隐私政策', href: '/about' },
    { label: '服务条款', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/60" role="contentinfo">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-bold font-heading text-primary-500 whitespace-nowrap cursor-pointer">h漫画</Link>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
              精选成人漫画在线阅读平台<br />
              每日更新，高清流畅
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">{title}</h4>
              <ul className="flex flex-col gap-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-300/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} h漫画. 版权所有 | 仅供18岁以上读者阅读
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供成年人阅读，未成年人请勿浏览
          </p>
        </div>
      </div>
    </footer>
  );
}